import { render, staticRenderFns } from "./ymdCard.vue?vue&type=template&id=0024a3a0&scoped=true&"
import script from "./ymdCard.vue?vue&type=script&lang=js&"
export * from "./ymdCard.vue?vue&type=script&lang=js&"
import style0 from "./ymdCard.vue?vue&type=style&index=0&id=0024a3a0&prod&lang=css&"
import style1 from "./ymdCard.vue?vue&type=style&index=1&id=0024a3a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024a3a0",
  null
  
)

export default component.exports